'use strict';

angular.module('atex.dam').directive('damDateRange', function($translate) {

  var silentWatch = false;

  var customOpt;
  $translate.onReady().then(function(){
      customOpt = {
          'label': $translate.getTranslationTable().__CUSTOM_DATE_RANGE__,
          'value': "custom"
      };
  });

  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'views/dam-date-range.html',

    scope: {
      label: "=",
      objects: "=",
      dates: "=",
      sets: "=",
      hideCustom: "=",
      selectPresetCallBack: '&',
      hideLabel: "=",
      isTimestamp: "=",
      dateFormat: "=",
      allowClear: "=?",
      defaultPresetIndex: "=?"
    },

    link: function (scope, element, attrs) {
      function hasTime() {
        var _format =  scope.dateFormat || "DD/MM/YYYY";
        return _format.toLowerCase().indexOf("h") > -1;
      }

      function random() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      }

      function id() {
        return [random(), random()];
      }

      function checkAndSetDefaultPreset () {
        if (scope.defaultPresetIndex && !isNaN(scope.defaultPresetIndex)) {
          if (scope.presets && scope.presets.length > scope.defaultPresetIndex) {
            scope.model.selectedOption = scope.presets[scope.defaultPresetIndex];
            scope.preset = angular.copy(scope.presets[scope.defaultPresetIndex]);
            scope.setPreset(scope.presets[scope.defaultPresetIndex]);
          }
        }
      }

      if ('timestamp' in attrs) {
        scope.isTimestamp = true;
      }

      scope.preset = {};

      if (scope.sets) {
        scope.presets = angular.copy(scope.sets);
      } else {
        scope.presets = [];
      }


      //workaround to avoid missing custom option in ui-select due to failing translation
      if (!scope.hideCustom) {
        if (customOpt === undefined) {
          $translate.onReady().then(function () {
            return {
              'label': $translate.getTranslationTable().__CUSTOM_DATE_RANGE__,
              'value': "custom"
            };
          }).then(function (result) {
            customOpt = result;
            var index = scope.presets.indexOf(function (preset) {
              return preset.value === result.value;
            });
            if (index === -1) {
              scope.presets.push(customOpt);
            }
          });
        } else {
          scope.presets.push(customOpt);
        }
      }

      scope.model = {
        selectedOption: undefined
      };

      scope.allowClear = (scope.allowClear !== false);

      var clearDateRange = function () {
        if (!scope.dates) {
          scope.dates = [];
        }
        scope.dates.length = 0;
        scope.dates.push('');
        scope.dates.push('');
      };

      if (scope.objects === 'random') {
        scope.id = id();
      } else {
        scope.id = scope.objects.split('-');
      }

      scope.showDateRange = false;

      scope.presetChanged = function (val) {
        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      };

      scope.open = function (index) {
        var obj = element.find("input[date-picker-id='" + scope.id[index] + "']");
        obj.data("DateTimePicker").show();
      };

      scope.setPreset = function (preset) {
        if (preset === undefined) {
          clearDateRange();
          scope.showDateRange = false;
          scope.preset = {};
        } else if (preset === customOpt) {
          if (!scope.dates || scope.dates[0] || scope.dates[1]) {
            silentWatch = true;
          }
          clearDateRange();
          scope.showDateRange = true;
          scope.preset = {};
        } else {
          scope.dates = [];
          scope.showDateRange = false;
          scope.preset = angular.copy(preset);
          scope.dates.push(preset.value);
          delete scope.dates[1];
        }
        scope.presetChanged();
      };

      checkAndSetDefaultPreset();

      scope.$watch(function () {
        return scope.dates;
      }, function (newValue, oldValue) {
        if (silentWatch) {
          silentWatch = false;
          return;
        }
        if (!scope.dates || scope.dates.length === 0) {

          scope.model.selectedOption = undefined;
          scope.showDateRange = false;
          checkAndSetDefaultPreset();
          return;
        }
        // Check the array in case has been cleared by clearAdvancedFields of DamSearchFormController
        if (!(scope.dates instanceof Array)) {
          var a = scope.dates[0] === undefined ? '' : scope.dates[0];
          var b = scope.dates[1] === undefined ? '' : scope.dates[1];
          scope.dates = [];
          scope.dates.push(a);
          scope.dates.push(b);
        }
        var from = scope.dates[0];
        var to = scope.dates[1];
        if (from && to && from !== to && from !== "*" && to !== "*") {
          scope.showDateRange = true;
          scope.model.selectedOption = customOpt;
          var fromDate = new Date(from);
          var toDate = new Date(to);
          if (toDate < fromDate) {
            if (newValue[0] !== oldValue[0]) {
              if (scope.isTimestamp && !hasTime()) {
                // If working with timestamp, add 23:59:59.999
                fromDate.setMilliseconds(fromDate.getMilliseconds() + (24 * 60 * 60 * 1000 - 1));
                scope.dates[1] = fromDate.toISOString();
              } else {
                // If fromDate has changed Set 'to' equal to 'from'
                scope.dates[1] = from;
              }
            } else if (newValue[1] !== oldValue[1]) {
              // If toDate has changed Set 'from' equal to 'to'
              if (scope.isTimestamp && !hasTime()) {
                // If working with timestamp, subtract 23:59:59.999
                toDate.setMilliseconds(toDate.getMilliseconds() - (24 * 60 * 60 * 1000 - 1));
                scope.dates[0] = toDate.toISOString();
              } else {
                scope.dates[0] = to;
              }
            }
          }
        } else {
          var presetFound = false;
          if (from && !to) {
            // It's a preset
            angular.forEach(scope.presets, function (preset) {
              if (from === preset.value) {
                scope.model.selectedOption = preset;
                scope.showDateRange = false;
                presetFound = true;
              }
            });
          }
          if ((from || to) && !presetFound) {
            if (from && !to) {
              scope.dates[1] = from;
              if (scope.isTimestamp && !hasTime()) {
                var _to = new Date(from);
                // If working with timestamp and is 'to' Date, add 23:59:59.999
                _to.setMilliseconds(_to.getMilliseconds() + (24 * 60 * 60 * 1000 -1));
                scope.dates[1] = _to.toISOString();
              }
            } else if (to && !from) {
              scope.dates[0] = to;
              if (scope.isTimestamp && !hasTime()) {
                var _from = new Date(to);
                // If working with timestamp and is 'from' Date, remove 23:59:59.999
                _from.setMilliseconds(_from.getMilliseconds() - (24 * 60 * 60 * 1000 -1));
                scope.dates[0] = _from.toISOString();
              }
            }
            scope.model.selectedOption = customOpt;
            scope.showDateRange = true;
          } else if (!from && !to) {
            scope.showDateRange = false;
            scope.model.selectedOption = undefined;
          }
        }
      }, true);
    }

  };



});
